import RegisterBtnComponent from '@components/Default/Register/RegisterBtnComponent';
import SearchComponent from '@components/Default/Search/SearchComponent';
import NotificationRegisterComponent from '@components/Notification/notificationRegisterComponent';
import Page from '@components/Page';
import Table from '@components/TableComponent';
import { Notification } from '@interfaces/global/notification';
import { NotificationType } from '@interfaces/global/notification-type';
import NotificationService from '@services/global/Notification';
import NotificationComponent from '@src/helpers/_showNotifications';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import * as React from 'react';
import titleCase from 'title-case';

import { LocalStorageKeys } from './App';

export interface INotificationsContainerProps {
}

//TODO: Notification type as generic parameter to Notification Constructor
export interface INotificationsContainerState {
  notifications: INotifificationTableData[],
  filteredNotifications: INotifificationTableData[],
  isLoading: boolean,
  response: Notification[], //Used to keep original data fetched from the API to delete, update, etc
  isNotificationModalVisible: boolean,
  notificationId: string,
  notificationTitle: string,
  notificationType: any,
}

const notificationTableColumns = [{
  title: 'common.name',
  dataIndex: 'name',
  key: 'name',
  width: '15%',
}, {
  title: 'common.type',
  dataIndex: 'type',
  key: 'type',
}, {
  title: 'common.createdAt',
  dataIndex: 'createdAt',
  key: 'createdAt',
}, {
  title: 'table.notifications.subject',
  dataIndex: 'subject',
  key: 'subject',
}, {
  title: 'table.actions',
  dataIndex: 'action',
  key: 'action',
}];

interface INotifificationTableData {
  content: string,
  createdAt: number,
  id: string,
  key: string,
  name: string,
  subject: string,
  type: string,
};
export default class NotificationsContainer extends React.Component<INotificationsContainerProps, INotificationsContainerState> {

  private _notificationService: NotificationService;
  private _pillar: string;

  constructor(props: INotificationsContainerProps) {
    super(props);

    this.state = {
      filteredNotifications: [],
      isLoading: false,
      notifications: [],
      response: [],
      isNotificationModalVisible: false,
      notificationId: "",
      notificationTitle: "",
      notificationType: NotificationType.SMS, //Starting with email just because
    }

    this._pillar = String(localStorage.getItem(LocalStorageKeys.PILLAR));
    this._notificationService = new NotificationService(this._pillar);

    this.getNotifications = this.getNotifications.bind(this);
    this.toggleNotificationModal = this.toggleNotificationModal.bind(this);
    this.handleNotificationSearch = this.handleNotificationSearch.bind(this);
    this.onNotificationDelete = this.onNotificationDelete.bind(this);
    this.onNotificationEdit = this.onNotificationEdit.bind(this);
    this.onNotificationSave = this.onNotificationSave.bind(this);

  }

  componentDidMount() {
    console.log("componentDidMount");
    this.getNotifications();
  }

  async toggleNotificationModal() {
    this.setState({
      isNotificationModalVisible: !this.state.isNotificationModalVisible,
    })
  }

  async onNotificationSave() {
    await this.toggleNotificationModal();
    await this.getNotifications();
  }

  async handleNotificationSearch(event: any) {
    event.preventDefault();
    const term = String(event.target.find.value);
    const filteredNotifications = this.state.notifications.filter(x => x.name.toLowerCase() === term.toLowerCase());

    if(filteredNotifications) {
      await this.setState({
        filteredNotifications
      });
    }

    if(term === "") {
      await this.setState({
        filteredNotifications: []
      })
    }
  }

  async onNotificationEdit(notificationTableData: INotifificationTableData) {

    const notification = this.state.response.find(x => x.id === notificationTableData.id);
    // console.log('VALOR DA NOTIFICACAO', notification)

    if (notification) {
      this.setState({
        notificationId: notificationTableData.id,
        notificationType: notification.type,
        notificationTitle: notificationTableData.name
      });
    console.log('VALOR DA NOTIFICACAO', this.state.notificationType)


      this.toggleNotificationModal();
    }
    else {
      NotificationComponent.Notify('error', I18n.l("common.error"), I18n.l("table.notifications.editImpossible"));
    }
  }

  /**
   * Deletes notification from the database and removes it from the state
   * @param id Notification ID
   */
  async onNotificationDelete(id: string) {
    try {
      const notificationToDelete = this.state.response.find(x => x.id === id);

      if (notificationToDelete) {
        switch (notificationToDelete.type) {
          case NotificationType.SMS: {
            await this._notificationService.deleteSMSById(id);
            break;
          }
          case NotificationType.EMAIL: {
            await this._notificationService.deleteEmailById(id);
            break;
          }
          case NotificationType.PUSH: {
            await this._notificationService.deletePushById(id);
            break;
          }

          default: {
            throw new Error("Notification Type unknown")
          }
        }

        this.setState({
          notifications: this.state.notifications.filter(x => x.id !== id)
        });
        NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("table.notifications.deleteSuccessful"));
      }
    } catch (error) {
      console.log("error on delete", error);
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), error);
    }
  }


  /**
   * Gets all three types of notification
   */
  async getNotifications() {

    this.setState({
      isLoading: true
    });

    try {
      const pushNotifications = await this._notificationService.listAllPush();
      const smsNotifications = await this._notificationService.listAllSMS();
      const emailNotifications = await this._notificationService.listAllEmail();

      const notifications: INotifificationTableData[] = [];
      const response: Notification[] = [...pushNotifications, ...smsNotifications, ...emailNotifications];

      // Title cases notifications other than SMS, but creates a tightly coupled dependency
      response.forEach(notification => {
        notifications.push({
          content: notification.content,
          createdAt: notification.createdAt ? notification.createdAt : Date.now(),
          id: notification.id ? notification.id : Date.now().toString(),
          key: notification.id ? notification.id : Date.now().toString(),
          name: notification.name,
          subject: notification.subject,
          type: notification.type === NotificationType.SMS ? NotificationType[notification.type] : titleCase(NotificationType[notification.type]),
        })
      })

      this.setState({
        notifications,
        response
      });
    }

    catch (e) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), e);
    }

    this.setState({
      isLoading: false
    })
  }

  public render() {
    return (
      <Page>
        <Wrapper>
          {this.state.isLoading
            ? <p>{I18n.l("common.loadingData")}</p>
            :
            <React.Fragment>
              <Toolbar>
                <ToolbarItem>
                  <RegisterBtnComponent
                    onClick={this.toggleNotificationModal}
                    buttonText={I18n.l("table.notification.registerNotification")}
                  />
                </ToolbarItem>
                <ToolbarItem>
                  <SearchComponent
                    onSubmit={this.handleNotificationSearch}
                    placeholder='form.placeholders.formflowSearch'
                    //defaultValue={search}
                    buttonText='form.buttons.search'
                  />
                </ToolbarItem>
              </Toolbar>

              <div className='goepik-component-tablesize'>
                <Table
                  columns={notificationTableColumns}
                  data={this.state.filteredNotifications.length > 0 ? this.state.filteredNotifications : this.state.notifications}
                  onEdit={this.onNotificationEdit}
                  onDelete={this.onNotificationDelete}
                  noPagination={true}
                  showConfirmationModal={false}
                />
              </div>
            </React.Fragment>
          }
        </Wrapper>

        {this.state.isNotificationModalVisible && (
          <NotificationRegisterComponent
            client=""
            onCancelSelection={this.toggleNotificationModal}
            onSaveSelection={this.onNotificationSave}
            pillar={this._pillar}
            title={this.state.notificationTitle}
            type={this.state.notificationType as NotificationType}
            visible={this.state.isNotificationModalVisible}
            notificationId={this.state.notificationId}
          />
        )}
      </Page>
    );
  }
};

//#region CSS
const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
`;

const Toolbar = styled.div`
  flex: 0;
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 40px;
  width: 100%;
`;

const ToolbarItem = styled.div`
  flex: 1;
  margin-left: 50px;
  &:first-of-type {
    flex: 0;
    margin-left: 0;
  }
`;
//#endregion
